import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Categories from "../pages/categories/page";
import CategoryDetail from "../pages/category-detail/page";
import Articles from "../pages/articles/page";
import ArticleDetail from "../pages/article-detail/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/categories",
    element: <Categories />,
  },
  {
    path: "/category/:categoryId",
    element: <CategoryDetail />,
  },
  {
    path: "/articles",
    element: <Articles />,
  },
  {
    path: "/article/:articleId",
    element: <ArticleDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;